import React, { useContext } from 'react'

// Hooks
import {
  WalletReturnType,
  WALLET_INITIAL_STATE,
  useWallet,
} from 'hooks/useWallet'

const notInitialized = () => {
    throw new Error('Contract not initialized yet.')
}

const WalletContext =
    React.createContext<WalletReturnType>({ swapToTarget: notInitialized, ...WALLET_INITIAL_STATE } )

interface WalletProviderProps {
  children: React.ReactNode
}

export const WalletProvider = ({ children }: WalletProviderProps) => {
  const WalletState = useWallet()

  return (
    <WalletContext.Provider value={WalletState}>
      {children}
    </WalletContext.Provider>
  )
}

export const useWalletContext = () => useContext(WalletContext)
